import { render, staticRenderFns } from "./GymSubscriptionTypeList.vue?vue&type=template&id=357a680a"
import script from "./GymSubscriptionTypeList.vue?vue&type=script&lang=js"
export * from "./GymSubscriptionTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports